try {
  window.onload = function () {
    try {
      !(function(c,b,d,a){c[a]||(c[a]={});c[a].config={pid:"iw0okbwm8i@28a65da0057ae84",appType:"web",imgUrl:"https://arms-retcode.aliyuncs.com/r.png?",sendResource:true,enableLinkTrace:true,behavior:true,useFmp:true};
with(b)with(body)with(insertBefore(createElement("script"),firstChild))setAttribute("crossorigin","",src=d)
})(window,document,"https://retcode.alicdn.com/retcode/bl.js","__bl");

      if (window.HAS_BW_UPDATE_INIT != true) {
        new window.BrowserUpdate({
          versions: [6, 7, 8, 9],
          lang: 'en-us',
          mode: {
            mask: [6, 7, 8, 9],
            top: [10]
          }
        });
        window.HAS_BW_UPDATE_INIT = true;
      }
      // eslint-disable-next-line no-empty
    } catch (e) { }
  };
  // eslint-disable-next-line no-empty
} catch (e) { }

Array.prototype.find = Array.prototype.find || function(fn) {
  let arr = this;
  for (let i = 0; i < arr.length; i++) {
    if (fn(arr[i])) {
      return arr[i];
    }
  }
};

window.initCountry = function() {
  try {
    // hx 设置当前国家变量
    let urlcountry = (/.*?country=(\w{2})/.exec(location.search) || [])[1];
    let cookiecountry;
    if (this.document.cookie.indexOf('xman_us_t') > 0) {
      // hx 已登录
      cookiecountry = (/xman_us_f=.*?x_user=(\w{2})/.exec(document.cookie) || [])[1];
    } else {
      // hx 未登录
      cookiecountry = (/lpCountry=(\w{2})/.exec(document.cookie) || [])[1];
    }
    window._lpcountry = cookiecountry || urlcountry;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
};

// hx 加载xman 登陆弹框组件
window.initXman = function() {
  window.SCHD_COMS = window.SCHD_COMS || {};
  window.SCHD_COMS.aName = 'op-delivery-gateway';
  window.SCHD_COMS.modsConfig = window.SCHD_COMS.modsConfig || {};
  (function() {
    window.SCXmanConfig = window.SCXmanConfig || {
      enableKeepLogin: true,
      version: '1.0.2',
    };
    if (window.goldlog && window.goldlog.record) {
      let importVersion = 'gc';
      if (window.SCXmanConfig.isGlobalXman == true) {
        importVersion = 'gx';
      }
      window.goldlog.record('/sc.globalxman.appscene', 'EXP', 'scene=op-delivery-gateway_xman_' + importVersion, 'H1479648432');
    }
  })();
  window.SCHD_COMS.modsConfig.xman = {
    modLink: 'sc-global-components/20190318164849/entrances/xman/xman.css',
    modSrc: 'sc-global-components/20190318164849/entrances/xman/xman.js',
    modStandaloneSrc: 'sc-global-components/20190318164849/entrances/xman/standalone/xman.js',
  };

  window.getXmanObj = function() {
    // eslint-disable-next-line no-undef
    return new Promise(function(resolve) {
      if (window._selfXmanObj) {
        resolve(window._selfXmanObj);
      } else {
        try {
          window.SCHD_COMS.use([ 'xman' ], function() {
            let SCXman = window.SCHD_COMS.SCXman;
            if (SCXman) {
              window._selfXmanObj = new SCXman.Popup({
                members: 'both',
                locale: (/.?intl_locale=(.*?)("|;)/.exec(document.cookie) || [])[1] || 'en_US',
              });
              resolve(window._selfXmanObj);
            }
          });
        } catch (e) {
          resolve();
        }
      }
    });
  };
};

window.initLogFn = function() {
  window.chatlog = function() {
    window.getXmanObj().then(function(xmanObj) {
      let loginId = (/.?mid=(.*?)("|;)/.exec(document.cookie) || [])[1];
      let status = xmanObj && xmanObj.isLoggedIn() ? 'Y' : 'N';
      let defaultParam = 'loginid=' + loginId + '&status=' + status + '&platform=PC&' + location.search.slice(1);
      window.goldlog && window.goldlog.record('/sc.ggs_sso.lp_click', 'CLK', 'clickType=chatBtn&' + defaultParam);
    });
  };

  window.blockCLKLog = function(params) {
    window.getXmanObj().then(function(xmanObj) {
      let loginId = (/.?mid=(.*?)("|;)/.exec(document.cookie) || [])[1];
      let status = xmanObj && xmanObj.isLoggedIn() ? 'Y' : 'N';
      let defaultParam = 'loginid=' + loginId + '&status=' + status + '&platform=PC&' + location.search.slice(1);
      window.goldlog && window.goldlog.record('/sc.ggs_sso.lp_click', 'CLK', params + '&' + defaultParam);
    });
  };
};

window.initCountry();
window.initXman();
window.initLogFn();

window.listener = [];
window.registListener  = function(cb) {
  listener.push(cb);
};
window.triggerListener = function(countryCode) {
   listener.forEach(function(fn) {
     return fn(countryCode);
   });
};